export const users = [
  { id: "u-admin", name: "管理员", username: "admin", password: "admin", role: "系统管理员", department: "数字化管理中心" },
  { id: "u-gtm", name: "顾明远", username: "gumingyuan", password: "123456", role: "GTM负责人", department: "品类运营中心" },
  { id: "u-product", name: "周景行", username: "zhoujingxing", password: "123456", role: "产品负责人", department: "全球商品管理中心" },
  { id: "u-retail", name: "邓思源", username: "dengsiyuan", password: "123456", role: "零售负责人", department: "零售事业群" },
  { id: "u-channel", name: "许承业", username: "xuchengye", password: "123456", role: "渠道负责人", department: "高端零售销售中心" },
  { id: "u-ecom", name: "赵启航", username: "zhaoqihang", password: "123456", role: "电商负责人", department: "数字零售中心" },
  { id: "u-marketing", name: "张若诚", username: "zhangruocheng", password: "123456", role: "市场负责人", department: "全球品牌管理中心" },
  { id: "u-service", name: "王予安", username: "wangyuan", password: "123456", role: "服务负责人", department: "全球用户服务中心" },
  { id: "u-finance", name: "严知远", username: "yanzhiyuan", password: "123456", role: "财经协同人", department: "营销财务部" },
  { id: "u-it", name: "叶明澈", username: "yemingche", password: "123456", role: "IT协同人", department: "数字化管理中心" },
  { id: "u-gm", name: "陈嘉树", username: "chenjiashu", password: "123456", role: "品类总经理", department: "卫浴事业部" },
  { id: "u-vp", name: "李承泽", username: "lichengze", password: "123456", role: "VP运营", department: "集团运营中心" },
];

export const projects = [
  {
    id: "p-smart-toilet",
    name: "智能马桶GTM试点项目",
    productCategory: "智能马桶",
    targetChannel: "零售高定渠道 / 电商",
    currentStage: "launch_preparation",
    status: "normal",
    gtmOwnerId: "u-gtm",
    productOwnerId: "u-product",
    plannedLaunchDate: "2026-07-15",
    commercialGoal: "完成样板渠道导入，首销阶段验证GTM操盘机制",
  },
  {
    id: "p-shower",
    name: "恒温花洒上市项目",
    productCategory: "花洒",
    targetChannel: "零售渠道",
    currentStage: "market_expansion",
    status: "normal",
    gtmOwnerId: "u-gtm",
    productOwnerId: "u-product",
    plannedLaunchDate: "2026-08-20",
    commercialGoal: "完成重点门店导入和渠道激活",
  },
  {
    id: "p-vanity",
    name: "高定浴室柜经营复盘项目",
    productCategory: "浴室柜",
    targetChannel: "零售高定渠道",
    currentStage: "stable_sales",
    status: "at_risk",
    gtmOwnerId: "u-gtm",
    productOwnerId: "u-product",
    plannedLaunchDate: "2026-04-30",
    commercialGoal: "优化终端动销和服务体验反馈",
  },
];

export const tasks = [
  {
    id: "t-001",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    domain: "市场营销",
    title: "确认核心卖点与上市传播内容包",
    ownerId: "u-marketing",
    dueDate: "2026-05-12",
    status: "in_progress",
    priority: "P1",
  },
  {
    id: "t-002",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    domain: "零售",
    title: "完成样板门店导入节奏和导购培训计划",
    ownerId: "u-retail",
    dueDate: "2026-05-06",
    status: "in_progress",
    priority: "P1",
  },
  {
    id: "t-003",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    domain: "服务",
    title: "提交安装交付标准与售后FAQ",
    ownerId: "u-service",
    dueDate: "2026-05-10",
    status: "pending_review",
    priority: "P1",
  },
  {
    id: "t-004",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    domain: "电商",
    title: "完成电商详情页和首发活动页面检查",
    ownerId: "u-ecom",
    dueDate: "2026-05-15",
    status: "not_started",
    priority: "P2",
  },
  {
    id: "t-005",
    projectId: "p-shower",
    stageKey: "market_expansion",
    domain: "渠道",
    title: "输出核心渠道导入清单",
    ownerId: "u-channel",
    dueDate: "2026-05-14",
    status: "in_progress",
    priority: "P2",
  },
  {
    id: "t-006",
    projectId: "p-vanity",
    stageKey: "stable_sales",
    domain: "财经",
    title: "完成阶段经营分析简报",
    ownerId: "u-finance",
    dueDate: "2026-05-03",
    status: "in_progress",
    priority: "P1",
  },
];

export const readinessItems = [
  {
    id: "r-001",
    projectId: "p-smart-toilet",
    dimension: "产品成熟度",
    title: "产品版本与规格确认",
    ownerId: "u-product",
    status: "ready",
    evidence: "规格确认单已提交",
  },
  {
    id: "r-002",
    projectId: "p-smart-toilet",
    dimension: "市场传播准备",
    title: "上市传播内容包",
    ownerId: "u-marketing",
    status: "preparing",
    evidence: "卖点已确认，主视觉待定稿",
  },
  {
    id: "r-003",
    projectId: "p-smart-toilet",
    dimension: "零售终端准备",
    title: "导购培训覆盖",
    ownerId: "u-retail",
    status: "blocked",
    evidence: "培训排期未完成",
    blockerNote: "样板门店名单未最终确认",
  },
  {
    id: "r-004",
    projectId: "p-smart-toilet",
    dimension: "服务交付准备",
    title: "安装交付与售后知识库",
    ownerId: "u-service",
    status: "basically_ready",
    evidence: "FAQ初稿已完成",
  },
  {
    id: "r-005",
    projectId: "p-smart-toilet",
    dimension: "电商承接准备",
    title: "详情页和活动页就绪",
    ownerId: "u-ecom",
    status: "preparing",
    evidence: "页面结构已提交",
  },
  {
    id: "r-006",
    projectId: "p-smart-toilet",
    dimension: "财经预算与价格准备",
    title: "价格政策边界确认",
    ownerId: "u-finance",
    status: "basically_ready",
    evidence: "测算表已提交",
  },
  {
    id: "r-007",
    projectId: "p-smart-toilet",
    dimension: "系统与数据准备",
    title: "主数据与看板字段准备",
    ownerId: "u-it",
    status: "preparing",
    evidence: "字段清单待确认",
  },
  {
    id: "r-008",
    projectId: "p-shower",
    dimension: "产品成熟度",
    title: "恒温花洒规格确认",
    ownerId: "u-product",
    status: "basically_ready",
    evidence: "规格初稿已完成",
  },
  {
    id: "r-009",
    projectId: "p-shower",
    dimension: "渠道政策准备",
    title: "渠道定价与激励政策",
    ownerId: "u-channel",
    status: "preparing",
    evidence: "定价测算进行中",
  },
  {
    id: "r-010",
    projectId: "p-shower",
    dimension: "市场传播准备",
    title: "花洒卖点与传播素材",
    ownerId: "u-marketing",
    status: "preparing",
    evidence: "卖点待确认",
  },
  {
    id: "r-011",
    projectId: "p-vanity",
    dimension: "产品成熟度",
    title: "高定浴室柜产品定型",
    ownerId: "u-product",
    status: "ready",
    evidence: "已量产验证",
  },
  {
    id: "r-012",
    projectId: "p-vanity",
    dimension: "零售终端准备",
    title: "终端门店陈列方案",
    ownerId: "u-retail",
    status: "blocked",
    blockerNote: "高定门店装修延期",
    evidence: "方案待调整",
  },
  {
    id: "r-013",
    projectId: "p-vanity",
    dimension: "服务交付准备",
    title: "定制安装交付标准",
    ownerId: "u-service",
    status: "basically_ready",
    evidence: "标准初稿已完成",
  },
];

export const reviews = [
  {
    id: "rv-001",
    projectId: "p-smart-toilet",
    stageKey: "planning_initiation",
    reviewType: "initiation_review",
    title: "智能马桶立项评审",
    scheduledAt: "2026-04-12",
    status: "closed",
    decision: "approved",
    decisionNote: "通过立项，进入上市路径设计",
  },
  {
    id: "rv-002",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    reviewType: "launch_readiness_review",
    title: "智能马桶上市准备评审",
    scheduledAt: "2026-05-20",
    status: "open",
    decision: "deferred",
    decisionNote: "等待零售培训与电商页面准备更新",
  },
  {
    id: "rv-003",
    projectId: "p-shower",
    stageKey: "expansion_preparation",
    reviewType: "launch_path_review",
    title: "恒温花洒上市路径评审",
    scheduledAt: "2026-05-18",
    status: "open",
    decision: "conditionally_approved",
    decisionNote: "渠道导入清单补齐后通过",
  },
];

export const risks = [
  {
    id: "risk-001",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    domain: "零售",
    type: "风险",
    title: "样板门店名单未确认，影响导购培训排期",
    ownerId: "u-retail",
    dueDate: "2026-05-11",
    priority: "P1",
    status: "open",
    escalationFlag: true,
  },
  {
    id: "risk-002",
    projectId: "p-smart-toilet",
    stageKey: "launch_preparation",
    domain: "IT",
    type: "问题",
    title: "上市看板字段口径待确认",
    ownerId: "u-it",
    dueDate: "2026-05-13",
    priority: "P2",
    status: "open",
    escalationFlag: false,
  },
  {
    id: "risk-003",
    projectId: "p-vanity",
    stageKey: "stable_sales",
    domain: "服务",
    type: "风险",
    title: "安装反馈问题关闭率低于预期",
    ownerId: "u-service",
    dueDate: "2026-05-09",
    priority: "P0",
    status: "open",
    escalationFlag: true,
  },
];

export const messages = [
  {
    id: "msg-001",
    userId: "u-gtm",
    type: "risk",
    title: "P1 风险升级提醒",
    content: "样板门店名单未确认，影响导购培训排期，已被标记为升级事项。",
    read: false,
    createdAt: "2026-05-08",
  },
  {
    id: "msg-002",
    userId: "u-gtm",
    type: "task",
    title: "任务即将超期",
    content: "零售-完成样板门店导入节奏和导购培训计划 将于 2026-05-06 到期，请尽快跟进。",
    read: false,
    createdAt: "2026-05-08",
  },
  {
    id: "msg-003",
    userId: "u-gtm",
    type: "review",
    title: "评审待决策",
    content: "智能马桶上市准备评审等待您的审批意见。",
    read: true,
    createdAt: "2026-05-07",
  },
  {
    id: "msg-004",
    userId: "u-retail",
    type: "task",
    title: "新任务分配",
    content: "GTM负责人为您分配了「完成样板门店导入与导购培训」任务。",
    read: false,
    createdAt: "2026-05-08",
  },
  {
    id: "msg-005",
    userId: "u-marketing",
    type: "task",
    title: "任务待确认",
    content: "请确认核心卖点与上市传播内容包的输出物。",
    read: false,
    createdAt: "2026-05-07",
  },
  {
    id: "msg-006",
    userId: "u-service",
    type: "risk",
    title: "安装反馈问题",
    content: "浴室柜项目安装反馈问题关闭率低于预期，请关注。",
    read: true,
    createdAt: "2026-05-06",
  },
  {
    id: "msg-007",
    userId: "u-gtm",
    type: "system",
    title: "系统更新",
    content: "GTM操盘工作台已完成新一轮数据更新，新增智能马桶试点项目模板。",
    read: true,
    createdAt: "2026-05-05",
  },
];

export const templates = [
  {
    id: "tpl-task-launch-prep",
    type: "任务模板",
    name: "上市准备阶段标准任务包",
    stageKey: "launch_preparation",
    items: [
      { domain: "市场营销", title: "确认上市传播内容包", ownerId: "u-marketing", priority: "P1" },
      { domain: "零售", title: "完成样板门店导入与导购培训", ownerId: "u-retail", priority: "P1" },
      { domain: "服务", title: "提交安装交付标准与售后FAQ", ownerId: "u-service", priority: "P1" },
      { domain: "电商", title: "完成详情页与首发活动页面检查", ownerId: "u-ecom", priority: "P2" },
      { domain: "财经", title: "确认价格政策与预算边界", ownerId: "u-finance", priority: "P1" },
      { domain: "IT", title: "确认主数据与看板字段准备", ownerId: "u-it", priority: "P2" },
    ],
  },
  {
    id: "tpl-readiness-standard",
    type: "成熟度模板",
    name: "GTM上市准备成熟度九维检查",
    stageKey: "launch_preparation",
    items: ["产品成熟度", "市场传播准备", "零售终端准备", "渠道政策准备", "服务交付准备", "电商承接准备", "供应链与库存准备", "系统与数据准备", "财经预算与价格准备"],
  },
  {
    id: "tpl-review-standard",
    type: "评审模板",
    name: "GTM四类关键评审",
    stageKey: "all",
    items: ["立项评审", "上市路径评审", "上市准备评审", "首销复盘评审"],
  },
];

export const stageHistory = [
  {
    id: "sh-001",
    projectId: "p-smart-toilet",
    fromStage: "planning_initiation",
    toStage: "expansion_preparation",
    operatorId: "u-gtm",
    timestamp: "2026-03-15T10:00:00Z",
    note: "从「规划与立项」流转至「拓展准备」",
  },
  {
    id: "sh-002",
    projectId: "p-smart-toilet",
    fromStage: "expansion_preparation",
    toStage: "market_expansion",
    operatorId: "u-gtm",
    timestamp: "2026-04-01T14:30:00Z",
    note: "从「拓展准备」流转至「市场拓展」",
  },
  {
    id: "sh-003",
    projectId: "p-smart-toilet",
    fromStage: "market_expansion",
    toStage: "launch_preparation",
    operatorId: "u-gtm",
    timestamp: "2026-04-20T09:15:00Z",
    note: "从「市场拓展」流转至「上市准备」",
  },
];

export const kpiRecords = [
  { id: "kpi-001", projectId: "p-vanity", metric: "首销目标达成率", value: 92, target: 100, unit: "%", period: "2026-Q1", recordedAt: "2026-04-01" },
  { id: "kpi-002", projectId: "p-vanity", metric: "渠道导入完成率", value: 85, target: 100, unit: "%", period: "2026-Q1", recordedAt: "2026-04-01" },
  { id: "kpi-003", projectId: "p-vanity", metric: "门店培训覆盖率", value: 78, target: 90, unit: "%", period: "2026-Q1", recordedAt: "2026-04-01" },
  { id: "kpi-004", projectId: "p-vanity", metric: "电商页面上线及时率", value: 100, target: 100, unit: "%", period: "2026-Q1", recordedAt: "2026-04-01" },
  { id: "kpi-005", projectId: "p-vanity", metric: "服务问题关闭率", value: 88, target: 95, unit: "%", period: "2026-Q1", recordedAt: "2026-04-01" },
  { id: "kpi-006", projectId: "p-vanity", metric: "用户反馈问题数", value: 23, target: 0, unit: "条", period: "2026-Q1", recordedAt: "2026-04-01" },
  { id: "kpi-007", projectId: "p-smart-toilet", metric: "首销目标达成率", value: 0, target: 100, unit: "%", period: "2026-Q2", recordedAt: "2026-05-01" },
  { id: "kpi-008", projectId: "p-smart-toilet", metric: "渠道导入完成率", value: 45, target: 100, unit: "%", period: "2026-Q2", recordedAt: "2026-05-01" },
];
